/******************************************
 *  Author : Suraj Sharma
 *  Created On : Mon Dec 28 2020
 *  File : AuthConstants.js
 *******************************************/
const authStatuses = {
    AUTHENTICATED: 'AUTHENTICATED',
    LOGGED_OUT: 'LOGGED_OUT',
}

export default authStatuses;